import React from 'react'
import { Grid, virtualizedGridRenderer } from '@integec/grid-tools'
import { rowHeaderRender } from 'core/utils'
import {
  dateTimeCol,
  intCol,
  numCol,
  strCol,
} from '@integec/grid-tools/lib/cols'
import { eventDescWidth } from 'marginanalysis/Headers'

const EventDataTrueUp = props => {
  const { width, height, events } = props

  return (
    <div style={{ minHeight: height < 200 ? '200px' : height + 'px' }}>
      <Grid
        // ref={this.GridRef}
        // editMode="cell"
        data={events || []}
        headers={OaEventIoHeaders(width)}
        altBgColor="#ebebeb"
        render={virtualizedGridRenderer({
          // autoFixColByKey,
          rowHeaderRender,
          height: height < 200 ? 200 : height,
          width,
          headerRowHeight: 30,
        })}
        // onSelectionChange={selected => {
        //   this.selectionChange(selected)
        // }}
        // initialSortOptions={sortOptions}
        // sortOptions={sortOptions}
        // sortEnabled={sortEnabled}
        // isEditable={isEditable}
        selectionType="row"
        selectionMode="single"
      />
    </div>
  )
}

export default EventDataTrueUp

const OaEventIoHeaders = totalWidth => [
  intCol({ ident: 'eventnum', display: 'Event #', isFiltered: true }),
  strCol({ ident: 'eventtype', display: 'Event Type', isFiltered: true }),
  dateTimeCol({
    ident: 'eventstart',
    display: 'Event Start',
    isFiltered: true,
    width: 150,
    displayFormat: 'MM/DD/YYYY HH:mm',
  }),
  dateTimeCol({
    ident: 'eventend',
    display: 'Event End',
    isFiltered: true,
    width: 150,
    displayFormat: 'MM/DD/YYYY HH:mm',
  }),
  numCol({
    ident: 'availcap',
    display: 'Avail MW',
    isFiltered: true,
    displayFormat: '0,0.00',
  }),
  numCol({
    ident: 'euorAdjMW',
    display: 'EUOR Adj MW',
    isFiltered: true,
    displayFormat: '0,0.00',
  }),
  numCol({
    ident: 'lostOppMwh',
    display: 'Lost MWH',
    isFiltered: true,
    displayFormat: '0,0.00',
  }),
  numCol({
    ident: 'lostEhrs',
    display: 'Lost Eqv Hrs',
    isFiltered: true,
    displayFormat: '0,0.00',
  }),
  numCol({
    ident: 'avgEcoMin',
    display: 'ECO Min Rate',
    isFiltered: true,
  }),

  numCol({
    ident: 'wtvGenCost',
    display: 'Wt. Avg. Gen Cost',
    isFiltered: true,
  }),
  numCol({
    ident: 'avgDALmp',
    display: 'DA LMP',
    isFiltered: true,
  }),
  numCol({
    ident: 'avgRTLmp',
    display: 'RT LMP',
    isFiltered: true,
  }),
  numCol({
    ident: 'avgLmp',
    display: 'Wt. Avg. LMP',
    isFiltered: true,
  }),
  numCol({
    ident: 'trueUp',
    display: 'CommOps True Up',
    isFiltered: true,
  }),
  numCol({
    ident: 'trueUpInc',
    display: 'True Up',
    isFiltered: true,
  }),

  strCol({
    ident: 'fuelType',
    display: 'Fuel Type',
    isFiltered: true,
  }),

  intCol({
    ident: 'causecode',
    display: 'Cause Code',
    isFiltered: true,
    displayFormat: '0',
  }),
  strCol({
    ident: 'causeDescrip',
    display: 'Cause Description',
    isFiltered: true,
    width: 400,
    ellipsis: true,
    alignment: 'left',
  }),
  strCol({
    ident: 'description',
    display: 'Description',
    isFiltered: true,
    width: eventDescWidth(totalWidth),
    ellipsis: true,
    alignment: 'left',
  }),
]
